import { Popover }         from "@mantine/core";
import { useClickOutside } from "@mantine/hooks";
import { useRouter }       from "next/router";
import { useState }        from "react";

import { useGetDeviceType }   from "_common/hooks/global";
import BackgroundWrapper      from "_components/atoms/backgroundWrapper";
import Icon                   from "_components/atoms/icon";
import MobileTabs             from "_components/molecules/mobile/tabs";
import SearchTextField        from "_components/molecules/searchTextField";
import Tabs                   from "_components/molecules/tabs";
import SearchPopOver          from "_components/organisms/searchPopOver";
import SearchResultsContainer from "_components/organisms/searchResultsContainer";

import useStyles      from "./mobile.styles";
import { formatTabs } from "./utils";

const component = ( { searchTerm, setSearchTerm, activeTab, tabs, changeTab, initialData } ) => {

	const [ popoverOpened, setPopoverOpened ] = useState ( false );
	const ref                                 = useClickOutside ( () => setPopoverOpened ( false ) );
	const router                              = useRouter ();
	const { classes }                         = useStyles ( { searchTerm } );
	const deviceType                          = useGetDeviceType ();
	const isMobile                            = deviceType === "mobile";
	const { query }                           = router.query || "";

	return (
		<BackgroundWrapper type = "secondary">
			<Popover
				id         = "input-popover"
				opened     = { popoverOpened && searchTerm.length > 2 }
				position   = "bottom"
				transition = "pop"
				width      = "90%"

			>
				<Popover.Target>
					<div ref = { ref }>
						<div className = { classes.mobileSearchContainer }>
							<Icon
								className = { classes.backIcon }
								name      = "backArrow"
								onClick   = { router.back }
							/>

							<div
								style = { { flex: 1 } }
							>
								<SearchTextField
									onFocus      = { () => setPopoverOpened ( true ) }
									onPressEnter = { () => {
										if ( searchTerm.length === 0 ) return;
										router.push ( `/results/${ encodeURIComponent ( searchTerm ) }?tab=all` );
										setPopoverOpened ( false );
									} }
									onPressEsc   = { () => setPopoverOpened ( false ) }
									placeholder  = { popoverOpened ? "Search for Streamers, Videos, Games & More" : "Search" }
								/>
							</div>

						</div>
					</div>
				</Popover.Target>

				<Popover.Dropdown
					className = { classes.popOver }
				>
					<SearchPopOver
						popoverOpened             = { popoverOpened }
						searchTerm                = { searchTerm }
						setPopoverOpened          = { setPopoverOpened }
						setSearchTerm             = { setSearchTerm }
					/>
				</Popover.Dropdown>
			</Popover>

			{
				isMobile ? (
					<MobileTabs
						key            = { activeTab }
						background     = "secondary"
						defaultTab     = { activeTab }
						onClickHandler = { val => changeTab ( val ) }
						tabs           = { formatTabs ( tabs ) }
					/>
				) : (
					<Tabs
						activeTab = { activeTab }
						list      = { formatTabs ( tabs ) }
						onChange  = { changeTab }
						variant   = "fullWidth"
					/>
				)
			}

			<SearchResultsContainer
				activeTab           = { activeTab }
				changeTab           = { changeTab }
				initialData         = { initialData }
				searchQuery         = { query }
			/>
		</BackgroundWrapper>
	);
};

export default component;
